import { render, staticRenderFns } from "./VideoMemberships.vue?vue&type=template&id=d608d460&scoped=true"
import script from "./VideoMemberships.vue?vue&type=script&lang=js"
export * from "./VideoMemberships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d608d460",
  null
  
)

export default component.exports